import { NgClass } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	inject,
	signal,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime } from 'rxjs';

import { ViewPortService } from '@valk-nx/services/viewport/src/lib/viewport.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [NgClass, TranslatePipe],
	selector: 'vp-read-more',
	templateUrl: './read-more.html',
})
export class ReadMoreComponent {
	private readonly viewPortService = inject(ViewPortService);

	expanded = signal(false);
	showToggle = signal(false);

	@ViewChild('content') content!: ElementRef<HTMLDivElement>;

	constructor() {
		this.viewPortService.screenWidth$
			.pipe(takeUntilDestroyed(), debounceTime(300))
			.subscribe(() => this.checkClamped());
	}

	checkClamped() {
		const el = this.content?.nativeElement;
		if (el) {
			this.showToggle.set(el.scrollHeight > el.clientHeight);
		}
	}

	toggle() {
		this.expanded.set(!this.expanded());
	}
}
